
(function() {
    'use strict';

    angular
        .module('vholsHeaderFooterDirectives', [
            'ipCookie'
        ])

        .config(["$provide", function($provide){

            var theGoodTouch = (('ontouchstart' in window)
                || (navigator.MaxTouchPoints > 0)
                || (navigator.msMaxTouchPoints > 0));

            $provide.constant('TOUCHY', theGoodTouch)

        }])
})();


(function() {
    'use strict';

    angular
        .module('vholsHeaderFooterDirectives')
        .directive('touchDetection', touchDetection);

    touchDetection.$inject = ['$rootScope', 'TOUCHY'];

    /*jshint latedef: false */
    /* @ngInject */
    function touchDetection ($rootScope, TOUCHY) {
        // Usage:
        //  stick it in your markup as an element or attribute <div touch-detection></div>
        // Creates:
        //  adds a class to the body tag: touch-enabled, touch-disabled and broadcasts the value of touchy
        var touchDetection = {
            link: link,
            restrict: 'EA',
        };
        return touchDetection;

        function link(scope, element, attrs) {

            if (TOUCHY) {
                angular.element(document.body)
                    .addClass('touch-enabled');
            } else {
                angular.element(document.body)
                    .addClass('touch-disabled');
            }

            $rootScope.$broadcast('touchy', TOUCHY);
        }
    }

})();


/*global angular, moment*/
(function() {

    angular.module('vholsHeaderFooterDirectives')
        /**
         * Checks for touch and adds the class
         * touch-enabled to the body element if found
         */

        .directive('browseSearch', function() {
			return {
				scope: {
					url: '@'
				},
				link: function($scope) {
                    $scope.searchQuery = '';

					$scope.search = function($event) {
						if ($event.type === 'click'
                            || $event.type === 'touchend'
                            || ($event.keyCode === 13)) {
							location.href = $scope.url + $scope.searchQuery;
						}
					};
				},
				templateUrl: 'header-search.html'
			};
		})

        .directive('pressRelease', function() {
            return {
                replace: true,
                link: function($scope) {
                    var now = moment().format('D^MM^YYYY');
                    var beginning = moment()
                        .subtract(3, 'months').format('D^MM^YYYY');
                    $scope.pressLink = '//www.virginholidays.co.uk/press/0/'
                        + beginning + '/' + now;
                },
                template: '<a ng-href="{{pressLink}}" class="footer-link press-link">Press</a>'
            };
        })

         /**
         * contact Us Mobile PopOver - controls for mobile contact us
         * @return Null
         */
        .directive('contactUsMobilePopOver', function() {
            return {
                scope: true,
                link: function ($scope, $element) {
                    $scope.$on('closeContactUsPopOver', function () {
                        var elTooltip = $element[0].querySelector('.complex-tooltip')
                        var elTemp = $element[0].querySelector('.complex-tooltip');
                        elTooltip.remove();
                        $element.append(elTemp);
                    });
                }
            }
        })

        /**
         * Display opening times - either full or just the time
         * @return Null
         */
        .directive('openingTimes', [function() {
            var times;

            return {
                replace: false,
                scope: {
                    type: '@',
                    day: '@',
                    monStart: '@',
                    monEnd: '@',
                    satStart: '@',
                    satEnd: '@',
                    sunStart: '@',
                    sunEnd: '@'
                },
                transclude: true,
                link: function($scope) {
                    if (!times) {
                        times = {
                            'mon': { 'text': 'Mon to Fri', 'start': $scope.monStart, 'end': $scope.monEnd },
                            'tue': { 'text': 'Mon to Fri', 'start': $scope.monStart, 'end': $scope.monEnd },
                            'wed': { 'text': 'Mon to Fri', 'start': $scope.monStart, 'end': $scope.monEnd },
                            'thu': { 'text': 'Mon to Fri', 'start': $scope.monStart, 'end': $scope.monEnd },
                            'fri': { 'text': 'Mon to Fri', 'start': $scope.monStart, 'end': $scope.monEnd },
                            'sat': { 'text': 'Saturday', 'start': $scope.satStart, 'end': $scope.satEnd },
                            'sun': { 'text': 'Sunday', 'start': $scope.sunStart, 'end': $scope.sunEnd }
                        };
                    }

                    $scope.times = times;

                    if (!$scope.day) {
                        var day = $scope.date = moment().format('ddd');
                        $scope.day = day.toLowerCase();
                    }
                },
                template: function($scope, $element) {
                    var tpl = $element.type === 'time' ? '<span class="qa-displayed-opening-time">{{times[day].start}} - {{times[day].end}}</span>'
                        : '<span class="pull-left">{{times[day].text}}</span> <span class="pull-right">{{times[day].start}} - {{times[day].end}}</span>';
                    return tpl;
                }
            };
        }])

        .directive('newsletterSignup',['$window', function($window) {
            return {
                scope: {
                    emailInput: '='
                },
                restrict: 'A',
                link: function ($scope, $element){

                    $element.on('click', function(e) {
                        var signUpUri = '/newsletter';
                        var bookFlowRegex = new RegExp('^/holiday/|^/hotel|^/flydrive|^/payments');
                        var params = [];
                        var referrerSource = bookFlowRegex.test(location.pathname)
                            ? 'referrerSource=bookflow' : '';
                        if ($scope.emailInput) {
                            params.push('referrerEmail=' + $scope.emailInput);
                        }

                        if (bookFlowRegex.test(location.pathname)) {
                            params.push('referrerSource=bookflow');
                        }
                        signUpUri += '?' + params.join('&');
                        e.preventDefault();
                        $window.location.href = signUpUri;
                    });
                }
            };
        }])

        .directive('placeHolder', function() {
            return {
                restrict: 'AC',
                link: function(scope, element, attr) {
                    if(document.createElement("input").placeholder == undefined) {
                        element.val(attr.placeholder);
                    }
                }
            };
        })

        .directive('mobileMegaMenu', ['$rootScope', function($rootScope) {
            var rightIn = 'right-in';
            var rightOut = 'right-out';
            var rightOne = 'right-one';
            var leftOne = 'left-one';
            var leftIn = 'left-in';

            function removeClasses($elem, classes) {
                classes.forEach(function(clazz) {
                    $elem.removeClass(clazz);
                });
            }

            function addClasses($elem, classes) {
                classes.forEach(function(clazz) {
                    $elem.addClass(clazz);
                });
            }

            return {
                scope: {
                    mobileMegaMenu: '@',
                    menuLevel: '@',
                    reverse: '@',
                    submenus: '@'
                },
                link: function($scope, $element) {
                    if ($scope.submenus && $scope.submenus === 'true') {
                        var $thisLevel = angular.element(document.querySelectorAll('.first-level-list'));
                        var $zeroLevel = angular.element(document.querySelectorAll('.zero-level'));
                        var yDist, yStart;

                        function downTheMenu() {
                            if ($scope.menuLevel === '0') {
                                var $firstLevel = angular.element(document.querySelectorAll('.first-level-' + $scope.mobileMegaMenu));

                                $zeroLevel.addClass(leftOne);
                                removeClasses($zeroLevel, [rightIn, leftIn]);

                                removeClasses($firstLevel, [rightOne, rightOut]);
                                $firstLevel.addClass(rightIn);

                                return $firstLevel;
                            } else if ($scope.menuLevel === '1') {
                                var $upperLevel = $element.parent().parent();
                                var upNum = 0;
                                var upperClassList = $upperLevel[0].classList;

                                for (var index = 0; index < upperClassList.length; index ++) {
                                    var data = upperClassList[index];

                                    if (data.match(/first-level-(\d)/)) {
                                        upNum = parseInt(data.substring(data.lastIndexOf('-') + 1, data.length), 10);
                                    }
                                }

                                var $secondLevel = angular.element(document.querySelectorAll('.second-level-' + upNum + '-' + $scope.mobileMegaMenu));

                                $thisLevel.addClass(leftOne);
                                removeClasses($thisLevel, [rightIn, leftIn]);

                                removeClasses($secondLevel, [rightOne, rightOut]);
                                $secondLevel.addClass(rightIn);

                                return $secondLevel;
                            }
                        }

                        function upTheMenu() {
                            if ($scope.menuLevel === '1') {
                                addClasses($thisLevel, [rightOne, rightOut]);
                                removeClasses($thisLevel, [rightIn, leftIn, leftOne]);

                                $zeroLevel.removeClass(leftOne);
                                $zeroLevel.addClass(leftIn);

                                return $zeroLevel;
                            } else if ($scope.menuLevel === '2') {
                                var $upLevel = angular.element(document.querySelectorAll('.first-level-' + $scope.mobileMegaMenu));
                                var $thirdLevel = $element.parent().parent();

                                $upLevel.removeClass(leftOne);
                                $upLevel.addClass(leftIn);

                                addClasses($thirdLevel, [rightOne, rightOut]);
                                removeClasses($thirdLevel, [leftIn, rightIn]);

                                return $thirdLevel;
                            }
                        }

                        function resetMenu() {
                            var $firstLevel = angular.element(document.querySelectorAll('.first-level-list')),
                                $secondLevel = angular.element(document.querySelectorAll('.second-level-list'));

                            $zeroLevel.removeClass(leftOne);
                            removeClasses($firstLevel, [rightIn, leftIn, leftOne]);
                            $firstLevel.addClass(rightOne);
                            removeClasses($secondLevel, [rightIn, rightOut]);
                            $secondLevel.addClass(rightOne);
                        }

                        $element.on('touchstart', function($event) {
                            var touchobj = $event.changedTouches[0];
                            yDist = 0;
                            yStart = touchobj.pageY;
                        });

                        $element.on('touchend', function($event) {
                            $event.preventDefault();

                            var touchobj = $event.changedTouches[0];
                            yDist = Math.abs(touchobj.pageY - yStart);

                            if (yDist < 5 && !$scope.animating) {
                                $scope.animating = true;
                                var $animatingElem;

                                if (!$scope.reverse) {
                                    $animatingElem = downTheMenu();
                                } else {
                                    $animatingElem = upTheMenu();
                                }

                                $animatingElem.on('animationend', function() {
                                    $scope.animating = false;
                                });
                            }

                            $scope.$emit('resizeParent');
                        });

                        $scope.$on('$destroy', $rootScope.$on('resetMenu', resetMenu));
                    }
                }
            };
        }])

        .directive('mobileMegaMenuCollapse', function() {
            return {
                link: function($scope, $element, $attrs) {
                    var $collapse = $attrs.mobileMegaMenuCollapse;

                    $scope.$on('$destroy', $scope.$watch($collapse, function() {
                        if ($scope[$collapse]) {
                            $element.addClass('open');
                            resizeMegaMenu();
                        } else {
                            $element.removeClass('open');
                            $element.removeAttr('style');
                        }
                    }));

                    $scope.$on('$destroy', $scope.$on('resizeParent', resizeMegaMenu));

                    $scope.$on('$destroy', $scope.$on('closeMegaMenu', function() {
                        $scope.toggleHeaderNav = false;
                    }));

                    window.addEventListener('orientationchange', function (){
                        if ($scope[$collapse]) {
                            window.setTimeout(resizeMegaMenu, 100);
                        }
                    });

                    $scope.$on('$destroy', function() {
                        window.removeEventListener('orientationchange');
                    });

                    function resizeMegaMenu() {
                        var height = $element[0].querySelectorAll('.sub-menu-container')[0].scrollHeight;
                        $element.attr('style', 'height:' + height + 'px');
                    }
                }
            };
        })

        .directive('messageBanner', ['ipCookie', '$timeout', function(ipCookie, $timeout) {
            return {
                restrict: 'AE',
                scope: true,
                link: function($scope, $element, $attrs) {

                    var messageId = $attrs.messageBanner,
                        cookie = $attrs.cookie || 'messageBanner',
                        expires = parseInt($attrs.expires) || 30;

                    if (!ipCookie(cookie) || ipCookie(cookie).toString() !== messageId) {
                        $scope.showMessage = true;
                    }

                    if ($attrs.closeByLink) {
                        $timeout(function() {
                            var $link = $element.find('a');

                            $link.on('click', $scope.close);
                            $scope.$on('destroy', function() {
                                $link.off('click');
                            });
                        });
                    }

                    $scope.close = function() {
                        $scope.showMessage = false;
                        ipCookie(cookie, messageId, { expires: expires, expirationUnit: 'days', path: '/' });
                    };
                }
            };
        }])

        .directive('countdownClock', function () {
            return {
                scope: {
                    endTime: '@'
                },
                replace: true,
                link: function($scope, $element) {
                    function addZero($var) {
                        return $var < 10 ? '0' + $var : $var + '';
                    }

                    function addClock() {
                        $scope.$emit('clockShow');
                    }

                    if ($scope.endTime) {
                        (function updateTime(first) {
                            var endTime = moment($scope.endTime, 'DD-MMM-YYYY HH:mm');
                            var duration = moment.duration(endTime.diff(moment()));

                            if (first) {
                                if (duration.asSeconds() && duration.asSeconds() > 0) {
                                    addClock();
                                }
                            }

                            var days = duration.asDays();
                            var hours = duration.asHours();
                            var minutes = duration.asMinutes();
                            var seconds = duration.asSeconds();

                            $scope.days = Math.floor(days);
                            $scope.hours = Math.floor(hours - ($scope.days * 24));
                            $scope.minutes = Math.floor(minutes - (($scope.days * 24 * 60) + ($scope.hours * 60)));
                            $scope.seconds = Math.floor(seconds -
                                (($scope.days * 24 * 60 * 60) + ($scope.hours * 60 * 60) + ($scope.minutes * 60)));

                            $scope.seconds = addZero($scope.seconds);
                            $scope.minutes = addZero($scope.minutes);
                            $scope.hours = addZero($scope.hours);
                            $scope.days = addZero($scope.days);

                            if (!first) {
                                $scope.$apply();
                            }

                            setTimeout(updateTime, 1000);
                        })(true);
                    }

                },
                templateUrl: 'countdown-clock.html'
            };
        })

        .directive("sharedCountdown", function() {
             return {
                scope: true,
                link: function($scope) {
                    $scope.$on('clockShow', function() {
                        $scope.clockShow = true;
                    });
                }
            };
        })

        .directive('footerSearch', function() {
            return {
                scope: {
                    url: '@'
                },
                transclude: true,
                link: function($scope, element, attrs, ctrl, transclude) {
                    transclude($scope, function(clone) {
                        element.append(clone);
                    });

                    $scope.searchQuery = '';

                    $scope.search = function($event) {
                        if ($event.type === 'click' || $event.type === 'touchend' || ($event.keyCode === 13)) {
                            location.href = $scope.url + $scope.searchQuery;
                        }
                    };
                }
            }
        })

        .directive('newsletterPopup', ['$document', '$compile', '$templateCache', function($document, $compile, $templateCache) {
            var template = $templateCache.get('newsletter-popup.html');
            return {
                scope: {
                    popupType: "@newsletterPopup"
                },
                link: function($scope, element) {
                    var childScope,
                        popup,
                        bodyEl = $document.find('body'),
                        openBodyClass = 'newsletter-open';

                    $scope.submitted = false;

                    function removePopup() {
                        childScope.$destroy();
                        popup.remove();
                        if($scope.popupType === 'modal') {
                            bodyEl.removeClass(openBodyClass);
                        }
                        $scope.submitted = false;
                    }

                    function clickOff(e) {
                        if(e.target.getAttribute('class') && e.target.getAttribute('class').match("newsletter-popup-mask")) {
                            removePopup();
                        }
                    }

                    $scope.close = function() {
                        removePopup();
                    };

                    $scope.$on('newsletterFormSubmit', function() {
                        $scope.submitted = true;
                    });

                    element.on('click', function(e) {
                        e.preventDefault();
                        if (popup) {
                            removePopup();
                        }
                        $scope.$apply(function() {
                            childScope = $scope.$new();
                            popup = $compile(template)(childScope);
                            if($scope.popupType === 'modal') {
                                bodyEl.append(popup);
                                bodyEl.addClass(openBodyClass);
                                popup.on('click', clickOff);
                            } else {
                                element.after(popup);
                            }
                        });
                    });
                }
            }
        }])

        .directive ('newsletterSubscribe', ['newsletterSignupService', function(newsletterSignupService) {
            return {
                scope: true,
                link: function($scope, $element) {

                    var element = $element[0];

                    $scope.formData = {};
                    $scope.posting = false;

                    $element.on('submit', function(e) {
                        e.preventDefault();
                        $scope.posting = true;
                        newsletterSignupService.signup($scope.formData).then(successCallback, errorCallback);
                    });

                    function successCallback(response)  {
                        if (response.data.success) {
                            $scope.submitted = true;
                            $scope.$emit("newsletterFormSubmit");
                            scrollElement();
                        } else {
                            $scope.formData = {};
                            $scope.posting = false;
                        }
                    }

                    function errorCallback()  {
                        $scope.posting = false;
                    }

                    function scrollElement() {
                        if (element.getBoundingClientRect().top < 0) {
                            element.scrollIntoView();
                        }
                    }
                },
                templateUrl: 'newsletter-signup.html'
            }
        }])

        .directive('vholsEmail', function() {
            var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,4}\.[0-9]{1,4}\.[0-9]{1,4}\.[0-9]{1,4}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;
            return {
                require: '?ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    if (ctrl && ctrl.$validators.email) {
                        ctrl.$validators.email = function(modelValue) {
                            return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
                        };
                    }
                }
            };
        })

        .service('newsletterSignupService', ['$http', function ($http) {

            var url = '/.rest/newsletter/v1/signup';

            this.signup = function(data) {
                return $http.post(url, data);
            };
        }])

        .controller('HeaderController', ['$scope', '$document', '$log', 'TOUCHY', function($scope, $document, $log, TOUCHY) {

            $scope.touchy = false;


            activate()

            function activate(){

                $scope.touchy = TOUCHY;

                if(!(document.body.classList.contains('touch-disabled') || document.body.classList.contains('touch-enabled'))){
                    $log.warn('Mega Menu needs class touch-disabled or touch-enabled to work, use touch-detection directive');
                }

                //Is touch enabled on this device?
                $scope.$on('touchy', function(_, touchy) {
                    $scope.touchy = touchy;
                });
            }


            $scope.touchOff = function($event) {
                var $target = angular.element($event.target);

                if (!$target.hasClass('mega-menu-item')) {
                    closeEveryMenu();
                    $document.off('touchend', $scope.touchOff);
                }

                $scope.$apply();
            };

            var closeEveryMenu = function(megaMenu) {
                var mainMenu = megaMenu ? megaMenu : $scope.megaMenu;

                mainMenu.forEach(function(menu) {
                    menu.open = false;

                    if (menu.hasSubMenus) {
                        closeEveryMenu(menu.subMenu);
                    }
                });
            };

            //megaMenu is created in the a ng-init in the header.html file.
            $scope.$watch('megaMenu', function() {
                if ($scope.megaMenu.length > 0) {
                    $scope.megaMenu.forEach(function(menu, $index) {
                        menu.level = 0;
                        menu.position = $index;

                        if (menu.hasSubMenus) {
                            var subMenu = menu.subMenu;

                            subMenu.forEach(function(subMenuItem, index) {
                                subMenuItem.level = 1;
                                subMenuItem.position = $index;
                                var count = index + 1;
                                var thirdOfLength = subMenu.length / 3;
                                var topMenu = (count > thirdOfLength);
                                var bottomMenu = (count > (subMenu.length - thirdOfLength));
                                var position = '';

                                if (bottomMenu) {
                                    position = 'bottom';
                                } else if (topMenu) {
                                    position = 'middle';
                                }

                                subMenuItem['subMenuPosition'] = position;
                            });
                        }
                    });
                }
            });


            $scope.tabletControl = function($event, menuItem) {

                if (TOUCHY && menuItem.hasSubMenus) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    var open = menuItem.open;

                    if (menuItem.level === 0) {
                        closeEveryMenu();
                    } else if (menuItem.level === 1) {
                        var $megaMenuCurr = $scope.megaMenu[menuItem.position];

                        $megaMenuCurr.open = true;

                        $megaMenuCurr.subMenu.forEach(function(megaMenuSub) {
                            megaMenuSub.open = false;
                        });
                    }

                    if (!open) {
                        $document.on('touchend', $scope.touchOff);
                    }

                    menuItem.open = !open;

                } else {
                    window.location = menuItem.link;
                }
            };

        }]);
})();


'use strict';

angular.module('vholsHeaderFooterDirectives').run(['$templateCache', function($templateCache) {

  $templateCache.put('countdown-clock.html', '<div class="countdown">\n	<div class="countdown-counters">\n		<div class="days countdown-counter" id="days">\n			<span class="day-char-one time-char">\n				{{days.slice(0, 1)}}\n			</span>\n			<span class="day-char-two time-char">\n				{{days.slice(1, 2)}}\n			</span>\n			<span class="countdown-label-all">Days</span>\n		</div>\n		<span class="divider pull-left">\n			:\n		</span>\n\n		<div class="hours countdown-counter" id="hours">\n			<span class="hour-char-one time-char">\n				{{hours.slice(0, 1)}}\n			</span>\n			<span class="hour-char-two time-char">\n				{{hours.slice(1, 2)}}\n			</span>\n			<span class="countdown-label-all">Hrs</span>\n		</div>\n		<span class="divider pull-left">\n			:\n		</span>\n\n		<div class="mins countdown-counter" id="mins">\n			<span class="time-char">\n				{{minutes.slice(0, 1)}}\n			</span>\n			<span class="time-char">\n				{{minutes.slice(1, 2)}}\n			</span>\n			<span class="countdown-label-all">Mins</span>\n		</div>\n		<span class="divider pull-left">\n			:\n		</span>\n\n		<div class="secs countdown-counter" id="secs">\n			<span class="time-char">\n				{{seconds.slice(0, 1)}}\n			</span>\n			<span class="time-char">\n				{{seconds.slice(1, 2)}}\n			</span>\n			<span class="countdown-label-all">Secs</span>\n		</div>\n	</div>\n</div>');

  $templateCache.put('header-search.html', '<div class="input-group">\n    <input class="form-control" ng-keypress="search($event)" ng-model="searchQuery" placeholder="Search our website" />\n    <span class="input-group-btn">\n        <button class="search-btn-header btn-primary btn" ng-click="search($event)">\n            <i class="icon-search"></i>\n        </button>\n    </span>\n</div>');

  $templateCache.put('newsletter-popup.html', '<div class="newsletter-popup-mask">\n    <i class="icon-cross close hidden-sm hidden-md hidden-lg" ng-click="close()"></i>\n     <div class="newsletter-popup-inner">\n         <div class="newsletter-popup">\n             <i class="icon-cross close hidden-xs" ng-click="close()"></i>\n             <newsletter-subscribe></newsletter-subscribe>\n             <div class="newsletter-popup-submitted" ng-show="submitted"><a ng-click="close($event)" class="close-submitted">Close</a></div>\n             <div class="newsletter-popup-tip"></div>\n         </div>\n     </div>\n</div>');

  $templateCache.put('newsletter-signup.html', '<div class="newsletter-signup-form">\n    <div ng-show="!submitted">\n        <div class="newsletter-heading heading-sm">\n            Sign up to receive news, offers and competitions from Virgin Holidays by email\n        </div>\n        <form name="newsletterSignupForm" track-form-event="Newsletter Signup Form">\n            <div class="newsletter-signup-form-fields">\n                <div class="newsletter-signup-form-field">\n                    <label for="newsletterSignupFormFname">First name</label>\n                    <input  id="newsletterSignupFormFname"\n                            class="form-control"\n                            type="text"\n                            ng-model="formData.forename"\n                            ng-model-options="{ debounce: 300 }"\n                            ng-pattern="/^([a-zA-Z-\'’` ]{2,255})$/"\n                            required=""\n                            name="forename"\n                            value="" />\n                </div>\n                <div class="newsletter-signup-form-field">\n                    <label for="newsletterSignupFormEmail">Email</label>\n                    <input  id="newsletterSignupFormEmail"\n                            type="email"\n                            class="form-control"\n                            required=""\n                            ng-model="formData.email"\n                            ng-model-options="{ debounce: 300 }"\n                            vhols-email \n                            snipe-email="Newsletter Signup Form"\n                            name="email"\n                            value="" />\n                    <button type="submit" ng-disabled="newsletterSignupForm.$invalid || posting" class="button button-secondary" ng-class="{\'posting\': posting}">Sign up</button>\n                </div>\n                <div class="error-section ng-cloak">\n                    <p ng-if="newsletterSignupForm.$invalid &amp;&amp; newsletterSignupForm.forename.$error.required &amp;&amp; newsletterSignupForm.forename.$dirty">Please enter a <span class="error-text">first name</span></p>\n                    <p ng-if="newsletterSignupForm.$invalid &amp;&amp; newsletterSignupForm.forename.$error.pattern &amp;&amp; newsletterSignupForm.forename.$dirty">Please enter a valid <span class="error-text">first name</span></p>\n                    <p ng-if="newsletterSignupForm.$invalid &amp;&amp; newsletterSignupForm.email.$error.required &amp;&amp; newsletterSignupForm.email.$dirty">Please enter an <span class="error-text">email address</span></p>\n                    <p ng-if="newsletterSignupForm.$invalid &amp;&amp; newsletterSignupForm.email.$error.email &amp;&amp; newsletterSignupForm.email.$dirty">Please enter a valid <span class="error-text">email address</span></p>\n                </div>\n                <div class="privacy-policy">\n                    For further details, please read our <a target="_blank" href="/important/privacy-statement">privacy policy.</a><br>\n                    You can unsubscribe at any time.\n                </div>\n                <button type="submit" ng-disabled="newsletterSignupForm.$invalid || posting" class="button button-primary" ng-class="{\'posting\': posting}">Sign up</button>\n            </div>\n        </form>\n    </div>\n    <div class="ng-cloak ng-hide" ng-show="submitted">\n        <h2 class="newsletter-heading">\n            Thanks for signing up\n        </h2>\n        <p class="newsletter-subheading">Keep an eye on your email for the latest special offers from us.</p>\n    </div>\n</div>');

}]);